// errors/MultipleValidationError.ts
import { BaseError } from "./BaseError.js";
var MultipleValidationError = class _MultipleValidationError extends BaseError {
  static {
    this._class = "MultipleValidationError";
  }
  constructor(validationErrors, extensions = {}) {
    validationErrors = validationErrors.flatMap((e) => e instanceof _MultipleValidationError ? e.validationErrors : [e]);
    extensions.validationErrors = validationErrors;
    if (!extensions.translationKey)
      extensions.translationKey = "multipleValidationErrors";
    super(
      "Multiple ValidationErrors were thrown during validation:\n" + validationErrors.map((err) => err.message).join("\n---\n"),
      extensions
    );
    this.validationErrors = validationErrors;
  }
  static createFromDetails(message, extensions) {
    return new this(extensions.validationErrors, extensions);
  }
};
export {
  MultipleValidationError
};
